import styled from 'styled-components';

export const CustomFormHeader = styled.div`
  margin-bottom: 12px !important;
`;

export const DrawerFields = styled.div`
  div.item {
    font-weight: 500;
    div.key {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: var(--color-smoke-700);
      margin-bottom: 8px;
      & > :not(:last-child) {
        margin-right: 6px;
      }
    }
    div.value {
      font-weight: 600;
      font-size: 14px;
      color: var(--color-elephant-900);
      word-break: break-all;
    }
    :not(:last-child) {
      margin-bottom: 24px;
    }
    button.transfer-button {
      margin: 12px 0 0 0;
    }
  }

  .custom-delete-btn {
    margin: 0;
    text-align: left;
    width: auto;
    color: var(--text-danger);
    border: none;
    background: none;
    padding: 0;
    line-height: 20px;
    &:hover {
      background-color: #fff;
    }
    &:focus {
      box-shadow: none;
    }
    &:active {
      border: none;
      box-shadow: none;
    }
  }

  .show-hide {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: var(--text-link);
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .custom-label {
    display: flex;
    align-items: center;
    a {
      padding-left: 10px;
      margin-bottom: 6px;
    }
  }
`;

export const Adornment = styled.div<{ position?: string }>`
  background: #f6f6f6;
  ${({ position }) =>
    position === 'start'
      ? 'border-right: 1px solid #cfd7df;'
      : 'border-left: 1px solid #cfd7df;'}
  font-size: 12px;
  line-height: 14px;
  color: #4b5165;
  padding: 10px 12px;
  white-space: nowrap;
  border-top-left-radius: ${({ position }) =>
    position === 'start' ? '4px' : '0'};
  border-bottom-left-radius: ${({ position }) =>
    position === 'start' ? '4px' : '0'};
  border-top-right-radius: ${({ position }) =>
    position === 'start' ? '0' : '4px'};
  border-bottom-right-radius: ${({ position }) =>
    position === 'start' ? '0' : '4px'};
`;

export const Message = styled.div`
  font-size: 14px;
  line-height: 24px;
  color: #12344d;
  word-break: break-word;
`;
